import dayjs from "dayjs";

const defaultSizes = [
  { xs: 12, md: 6 },
  { xs: 12, md: 6 },
];

const defaultMargin = '12px auto';

const checkDatesOrder = (date1, date2) => {
  if (!date1 || !date2 || !dayjs.isDayjs(date1) || !dayjs.isDayjs(date2)) {
    return false;
  }
  return !date1.isAfter(date2);
};

// Functions for tests
// const getDate = (date) => {
//   try {
//     return dayjs(date, 'DD/MM/YYYY');
//   } catch {
//     return null;
//   }
// };

// const getDates = (date1, date2) => {
//   let firstDate;
//   let secondDate;
//   let order = false;

//   try {
//     firstDate = dayjs(date1, 'DD/MM/YYYY');
//     secondDate = dayjs(date2, 'DD/MM/YYYY');
//     if (secondDate.isAfter(firstDate)) {
//       order = true;
//     }
//   } catch {
//     firstDate = null;
//     secondDate = null;
//   }

//   return { firstDate, secondDate, order };
// };

export {
  defaultSizes,
  defaultMargin,
  checkDatesOrder,
};